import { Layout, TileWidth, TileUtilities } from "../tileLayout/tiles";

export class TileActionBinding {
  /** Caption text to show under the normal heading text for the tile. */
  public caption = "@?";

  /** The glyph icon to use, shown visually preceding the title. */
  public icon = "@?";

  /** The color to use to indicate status on the tile. Valid values: "empty" is the default, while "red", "green", and "blue" all denote their colors. */
  public status = "@?";

  /** Controls the layout direction for the action. Supports "vertical" and "horizontal". The default is horizontal. */
  public layout = "@?";

  /** Callback invoked when a tile action is clicked. The callback does not support any arguments. */
  public onClick = "&";

  /** The text to display as the user-visible description of the action. */
  public text = "@";

  /** The width of the tile action, measured in TileWidth. Valid values are sourced from the TileWidth type ("x-small" | "small" | "medium" | "large" | "x-large" | "xx-large"). See the TileLayout page for more details.  */
  public width = "@";

  /** The business intelligence (BI) behavior for this component. Valid values are the enumeration names found in ServiceDesk.Services.PageActionBehavior enumeraiton.*/
  public biBehavior = "@?";
}

export class TileActionCotnroller {
  public caption: string;
  public colSpan: string;
  public hasCaption: boolean;
  public hasStatus: boolean;
  public icon: string;
  public isVertical = false;
  public layout: Layout;
  public onClick: () => void;
  public status: string;
  public statusClass: Array<string>;
  public text: string;
  public width: TileWidth;

  /** This gets executed upon clicking on the tile action div */
  public onSelected($event?: ng.IAngularEvent): void {
    if ($event) {
      $event.preventDefault();
    }

    if (angular.isFunction(this.onClick)) {
      this.onClick();
    }
  }

  public $onInit(): void {
    this.refreshView();
  }

  public $onChanges(changesObj: any): void {
    this.refreshView();
  }

  private refreshView() {
    this.hasCaption = this.caption && this.caption !== "" ? true : false;
    this.hasStatus = this.status && this.status !== "" ? true : false;
    this.colSpan = TileUtilities.getColumnsWidth(this.width);
    this.isVertical = this.layout && this.layout.toLowerCase() === "vertical" ? true : false;
    this.statusClass = [];
    if (this.hasStatus) {
      switch (this.status.toLowerCase()) {
        case "empty":
          this.statusClass.push("sd-glyph-empty-circle");
          this.statusClass.push("blue");
          break;
        case "red":
        case "green":
        case "blue":
          this.statusClass.push("sd-glyph-full-circle");
          this.statusClass.push(this.status.toLowerCase());
          break;
      }
    }
  }
}
export const sdTileAction: ng.IComponentOptions = {
  bindings: <any>new TileActionBinding(),
  controller: TileActionCotnroller,
  templateUrl: "../ShellCommon/Controls/tileAction/tileAction.html"
};
